import React from 'react';
import { Link } from 'react-router-dom';
import { Clock, ArrowRight } from 'lucide-react';

export const ServiceCard = ({ service }) => {
  return (
    <div className="bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
      <div className="relative h-48 overflow-hidden">
        <img 
          src={service.image} 
          alt={service.name}
          className="w-full h-full object-cover transition-transform duration-500 hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent"></div>
        <div className="absolute bottom-4 left-4 right-4">
          <h3 className="text-white font-bold text-xl">{service.name}</h3>
        </div>
      </div>
      <div className="p-6">
        <p className="text-gray-600 mb-4 min-h-[48px]">{service.shortDesc}</p>
        <div className="flex items-center gap-2 text-sm text-gray-500 mb-4">
          <Clock className="w-4 h-4" />
          <span>{service.duration}</span>
        </div>
        <Link 
          to={`/${service.slug}`}
          className="inline-flex items-center gap-2 text-[#00B4D8] font-semibold hover:text-[#0096C7] transition-colors"
        >
          Saiba mais
          <ArrowRight className="w-4 h-4" />
        </Link>
      </div>
    </div>
  );
};
